export default __webpack_public_path__ + "static/assets/0dc05c2808c7debbbdb402202791ee6b.gif";